module.exports = __webpack_public_path__ + "img/sponsors1.9dd128da.png";